import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { apiGet } from 'tennders-stracture/libs/api'
import {
  dispatchMapEditMode,
  dispatchMapForm,
  dispatchMapReset,
  dispatchRouteSelectable,
  dispatchSelectedDistance,
  dispatchSelectedRoute
} from '@/plugins/map/stores/action'

const useMap = () => {
  const [mapProps, setMapProps] = useState({})
  const dispatch = useDispatch()
  const selectedDistance = useSelector((state) => state.map.selectedDistance)
  const selectedRoute = useSelector((state) => state.map.selectedRoute)
  const routeSelectable = useSelector((state) => state.map.routeSelectable)
  const mapForm = useSelector((state) => state.map.mapForm)
  const editMode = useSelector((state) => state.map.editMode)
  const setSelectedDistance = (distance) => dispatch(dispatchSelectedDistance(distance))
  const setSelectedRoute = (route) => dispatch(dispatchSelectedRoute(route))
  const setMapForm = (form) => dispatch(dispatchMapForm(form))
  const setEditMode = (onOff) => dispatch(dispatchMapEditMode(onOff))
  const setRouteSelectable = (isSelectable) => {
    dispatch(dispatchRouteSelectable(isSelectable))
  }

  const resetMap = () => dispatch(dispatchMapReset(true))

  const getMapProps = async (id, fixedRoute) => {
    const response = await apiGet(`transactions/${id}/map-props`)
    setMapProps(response)
    if (response.content) {
      const opresponse = { ...response?.content }
      if (opresponse.distance) {
        setSelectedDistance(opresponse.distance)
      }
      if (opresponse.route) {
        setSelectedRoute(opresponse?.route)
      }

      const {
        pickupRoute,
        deliveryRoute,
        pickupStops,
        deliveryStops,
        distance,
        selectedRouteId,
        emptyKm,
        truckPickupRoute,
        route
      } = opresponse

      if (pickupRoute?.location && deliveryRoute?.location) {
        setMapForm({
          pickupRoute,
          deliveryRoute,
          pickupStops,
          deliveryStops,
          distance,
          selectedRouteId,
          truckPickupRoute,
          emptyKm,
          route,
          fixedRoute
        })
      }
    }
  }

  return {
    setSelectedDistance,
    selectedDistance,
    routeSelectable,
    setRouteSelectable,
    selectedRoute,
    setSelectedRoute,
    setMapForm,
    setEditMode,
    editMode,
    resetMap,
    mapForm,
    getMapProps,
    mapProps
  }
}

export default useMap
